import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getQueryParam } from '../../routing/getQueryParam';
import { getHublet } from '../../store/app/selectors';
import { getEmailSignatureGeneratorState } from '../../store/microapp/selectors';
import { getActiveExperiments } from '../../experiments/ExperimentUtils';
import { getRedirectSignupType } from '../../signup-completed-redirection/getRedirectSignupType';
import { getSurveyDataForRedirect } from '../../store/signup-data/selectors';
import { getAuth, getAuthUserId, getPortalId } from '../../store/auth/selectors';
import getOnboardingRedirectOptions from '../../signup-completed-redirection/getOnboardRedirectOptions';
import { getOnboardingRedirectUrl } from 'growth-onboarding-signup-redirect/redirect';
import { getCurrentStepNumbering } from '../../flow-management/stepNumberingSelectors';
export const fetchStoredData = state => {
  const dataId = getQueryParam('dataId');
  const hublet = getHublet(state);
  if (dataId) {
    return apiClient.get(`${getFullUrl('api', {
      hubletOverride: hublet
    })}/integrations-ai/v1/email-signature-generator-signup-bridge/data/${dataId}`);
  }
  return Promise.reject(new Error('No data id'));
};
export const storeEmailSignature = state => {
  const hublet = getHublet(state);
  const emailSignatureState = getEmailSignatureGeneratorState(state);
  const emailSignature = emailSignatureState.emailSignature;
  if (emailSignature) {
    return apiClient.put(`${getFullUrl('app-api', {
      hubletOverride: hublet
    })}/userpreferences/v1/signature`, {
      data: emailSignature,
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
  return Promise.reject(new Error('No email signature'));
};
export const fetchContacts = state => {
  const hublet = getHublet(state);
  return apiClient.post(`${getFullUrl('api', {
    hubletOverride: hublet
  })}/inbounddb-objects/v1/crm-objects/CONTACT`, {
    ignoreRedirect: true,
    data: {
      propertyValues: [{
        value: 'lead',
        name: 'lifecyclestage'
      }]
    }
  });
};
export const storeOnboardingUrl = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const auth = getAuth(state);
  const survey = getSurveyDataForRedirect(state);
  const signupType = getRedirectSignupType();
  const activeExperiments = getActiveExperiments(state);
  const {
    currentStep: signupStepNumber
  } = getCurrentStepNumbering(state);
  const onboardingRedirectOptions = getOnboardingRedirectOptions(portalId, signupType, hublet, auth, signupStepNumber, survey, activeExperiments);
  return Promise.resolve(getOnboardingRedirectUrl(onboardingRedirectOptions)).then(onboardingUrl => {
    return apiClient.patch(`${getFullUrl('api', {
      hubletOverride: hublet
    })}/integrations-ai/v1/email-signature-generator-signup-bridge/data/${getQueryParam('dataId')}`, {
      data: {
        replaceOnboardingUrl: onboardingUrl
      }
    });
  }).catch(error => {
    return Promise.reject(error);
  });
};
export const fetchOwners = state => {
  const hublet = getHublet(state);
  const userId = getAuthUserId(state);
  return apiClient.get(`${getFullUrl('api', {
    hubletOverride: hublet
  })}/owners/v2/owners/userId/${userId}?portalId=${getPortalId(state)}`).then(value => {
    const hasOwners = value && value.length > 0;
    return hasOwners || Promise.reject(new Error('No owners'));
  });
};